module.exports = __webpack_public_path__ + "media/components/outside-promo-page/static/mountain-forecast__icon-ea563e89b935abcb8919793ad3c5930a.svg";